import { Label, SidebarGroup, SidebarGroupContent, SidebarInput, SidebarGroupLabel } from '@quadminds/mindkit';
import { Search } from 'lucide-react';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

export function SearchForm({
    query,
    handleQuery,
    ...props
}: React.ComponentProps<'form'> & { query: string; handleQuery: (evt: ChangeEvent<HTMLInputElement>) => void }) {
    const { t } = useTranslation();
    return (
        <form {...props} className="p-2">
            <SidebarGroup className="py-0">
                <SidebarGroupLabel>{t('sideBar.chatList.title')}</SidebarGroupLabel>
                <SidebarGroupContent className="relative">
                    <Label htmlFor="search" className="sr-only">
                        {t('sideBar.chatList.searchLabel')}
                    </Label>
                    <SidebarInput
                        id="search"
                        placeholder={t('sideBar.chatList.searchPlaceholder')}
                        className="pl-8"
                        value={query}
                        onChange={handleQuery}
                    />
                    <Search className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 select-none opacity-50" />
                </SidebarGroupContent>
            </SidebarGroup>
        </form>
    );
}

export default SearchForm;
